import { render, staticRenderFns } from "./initial-amount.vue?vue&type=template&id=583625d7"
import script from "./initial-amount.vue?vue&type=script&lang=js"
export * from "./initial-amount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports